// extracted by mini-css-extract-plugin
module.exports = {"iframe":"Lesson1_iframe_18f_W","stage2":"Lesson1_stage2_2FDSY","button":"Lesson1_button_1klA0","img":"Lesson1_img_1w2Ar"};